import UploadHandler from './UploadHandler/UploadHandler';
import PendingAttachmentHandler from './PendingAttachmentHandler/PendingAttachmentHandler';

class UploadProcessManager {

    constructor(objectName, attachmentName, createPendingAttachmentIdUrl, file, policyHandler, shouldBeRenamed) {
        this.objectName = objectName;
        this.attachmentName = attachmentName;
        this.createPendingAttachmentIdUrl = createPendingAttachmentIdUrl;
        this.file = file;
        this.policyHandler = policyHandler;
        this.shouldBeRenamed = shouldBeRenamed;
        this.handleCreatePendingAttachmentIdLogic = this.handleCreatePendingAttachmentIdLogic.bind(this);
    }

    /**
     * Aborts upload transaction
     */
    abort() {
        this.uploadHandler && this.uploadHandler.abort();
    }

    async upload(
        onSuccess = () => ({}),
        onError = () => ({}),
        onProgress = () => ({}),
        retryAttempts = 5
    ) {
        try {
            const policyData = await this.policyHandler.validatePolicy(this.file);
            const s3ParsedData = await this.handleUploadLogic(policyData, this.file.type, onProgress, retryAttempts);
            const finalS3ParsedData = await this.handleCreatePendingAttachmentIdLogic(s3ParsedData, retryAttempts);

            onSuccess(finalS3ParsedData);
        } catch (error) {
            onError(error);
        }
    }

    handleUploadLogic(policyData, fileType, onProgress, retryAttempts) {
        this.uploadHandler = new UploadHandler(
            this.objectName,
            this.attachmentName,
            policyData,
            fileType,
            retryAttempts,
            this.file,
            onProgress,
            this.shouldBeRenamed
        );

        return this.uploadHandler.handleUploadLogic();
    }

    handleCreatePendingAttachmentIdLogic(s3ParsedData, retryAttempts) {
        const pendingAttachmentHandler = new PendingAttachmentHandler(
            this.objectName,
            this.attachmentName,
            this.createPendingAttachmentIdUrl,
            s3ParsedData,
            this.file,
            retryAttempts
        );

        return pendingAttachmentHandler.handleCreatePendingAttachmentIdLogic();
    }
}

export default UploadProcessManager;
